const scoreGradiant = [
  [
    // Green theme
    "hsl(0,0%,75%)", // 0
    "hsl(102,40%,74%)", // 1
    "hsl(111,53%,65%)", // 2
    "hsl(115,53%,54%)", // 3
    "hsl(119,61%,44%)", // 4
    "hsl(133,99%,29%)" // 5
  ],
  [
    // Muted theme
    "hsl(0,35%,47%)", // 0
    "hsl(29,52%,47%)", // 1
    "hsl(41,56%,50%)", // 2
    "hsl(59,53%,47%)", // 3
    "hsl(75,52%,47%)", // 4
    "hsl(120,50%,45%)" // 5
  ],
  [
    // Vivid theme
    "hsl(0,66%,44%)", // 0
    "hsl(28,100%,43%)", // 1
    "hsl(41,100%,49%)", // 2
    "hsl(58,100%,44%)", // 3
    "hsl(75,100%,43%)", // 4
    "hsl(120,100%,40%)" // 5
  ]
];

export { scoreGradiant };
